import { Globals } from './globals';
import { Query, UrlUtil } from '@hugendubel/utils';
import { TokenStore, WsClient } from '@hugendubel/ws_client';
import { OAuthScope } from './oauth-scope';

const isTempSession = (): boolean => {
    const query = UrlUtil.locationSearchToQuery(Globals.window().location.search) as Query;
    const scope = query.scope?.toLowerCase();
    return scope === OAuthScope.FAMILY;
};

const start = (): void => {
    if (isTempSession()) {
        TokenStore.startTemporarySession();
        WsClient.Controller.synchronize();
    } else {
        TokenStore.clearTemporarySession();
    }
};

const clear = (): void => {
    TokenStore.clearTemporarySession();
    WsClient.Controller.synchronize();
};

export const TempSessionForFamily = { isTempSession, start, clear };
